/**
 * Export `inputMasks` constant.
 */

export const inputMasks = {
  cpCode: '####-####-####',
  nif: '### ### ###'
};
